function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import PictureComponent from "components/core/picture/picture-component";
import DownArrow from "static/svg/small-down-arrow.svg";
import classnames from "classnames";
import { SECONDARY_BUTTON_TYPE, SIGNUP_BUTTON_TYPE, SIGNUP_COMBO_BUTTONS_TYPE } from "segments/desktop/core-components/button/button-consts";
import { XXS } from "components/core/new-button/button-component";
import { StyledProductCardGridMobileComponent } from "./product-card-grid-mobile-component.scss";
import ProductCardGridBodyComponent from "./product-card-grid-body-component";
import { trackEvent } from "/services/bigbrain-service";
import { MOBILE_PRODUCT_COMPONENT_OPENED, MOBILE_PRODUCT_COMPONENT_CLOSED } from "/constants/bigbrain-event-types";
import { productCardsImages, productIndexToProductType } from "segments/desktop/grid/layouts/product-cards-grid/default-props";
import { PRODUCTS_THEMES } from "/constants/products";
import { BUTTON_COLOR_BY_PRODUCT, SIGNUP_ID_BY_PRODUCT } from "./consts";
import classNames from "classnames";
const ProductCardGridMobileComponent = (props)=>{
    var _productCardsImages_productIndexToProductType_index;
    const { body, useCases, buttonConfig, productType, index, showOpen, header, isV2 } = props;
    const [isOpen, setIsOpen] = useState(showOpen);
    const onCardHeaderClick = ()=>{
        if (!isOpen) {
            trackEvent(MOBILE_PRODUCT_COMPONENT_OPENED, {
                kind: productType,
                index
            });
        } else {
            trackEvent(MOBILE_PRODUCT_COMPONENT_CLOSED, {
                kind: productType,
                index
            });
        }
        setIsOpen(!isOpen);
    };
    const getProductButtonConfig = ()=>{
        switch(buttonConfig.buttonType){
            case SIGNUP_BUTTON_TYPE:
                return _object_spread_props(_object_spread({}, buttonConfig), {
                    invert: isV2 ? false : true,
                    buttonSize: XXS,
                    buttonColor: isV2 && BUTTON_COLOR_BY_PRODUCT[productType],
                    signupProductId: isV2 && SIGNUP_ID_BY_PRODUCT[productType]
                });
            case SIGNUP_COMBO_BUTTONS_TYPE:
                return _object_spread_props(_object_spread({}, buttonConfig), {
                    signupButtonConfig: _object_spread_props(_object_spread({}, buttonConfig.signupButtonConfig), {
                        invert: true,
                        buttonSize: XXS
                    })
                });
            default:
                return buttonConfig;
        }
    };
    const getProductImage = ()=>{
        var _productCardsImages_productType, _productCardsImages_productType1;
        return isV2 ? productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType = productCardsImages[productType]) === null || _productCardsImages_productType === void 0 ? void 0 : _productCardsImages_productType.mobileImageV2 : productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType1 = productCardsImages[productType]) === null || _productCardsImages_productType1 === void 0 ? void 0 : _productCardsImages_productType1.mobileImage;
    };
    const productCardButtonConfig = getProductButtonConfig();
    const mobileImageProp = productType ? getProductImage() : productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productIndexToProductType_index = productCardsImages[productIndexToProductType[index]]) === null || _productCardsImages_productIndexToProductType_index === void 0 ? void 0 : _productCardsImages_productIndexToProductType_index.mobileImage;
    const productTheme = productType ? PRODUCTS_THEMES[productType] : PRODUCTS_THEMES[productIndexToProductType[index]];
    return /*#__PURE__*/ _jsx(StyledProductCardGridMobileComponent, {
        className: classnames("mobile-product-card", {
            open: isOpen
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-content",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "product-card-header",
                    onClick: onCardHeaderClick,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "product-card-header-content",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: classNames("product-card-header-image", {
                                        "is-v2": isV2
                                    }),
                                    children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, mobileImageProp))
                                }),
                                (header === null || header === void 0 ? void 0 : header.mobileSubTitleText) && /*#__PURE__*/ _jsx("div", {
                                    className: "product-card-header-text",
                                    children: header === null || header === void 0 ? void 0 : header.mobileSubTitleText
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("arrow", {
                                open: isOpen
                            }),
                            children: /*#__PURE__*/ _jsx(DownArrow, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classNames("mobile-product-card-body", {
                        "is-v2": isV2
                    }),
                    children: /*#__PURE__*/ _jsx(ProductCardGridBodyComponent, {
                        body: body,
                        showDivider: false,
                        useCases: useCases,
                        theme: productTheme,
                        productCardButtonConfig: productCardButtonConfig
                    })
                })
            ]
        })
    });
};
ProductCardGridMobileComponent.defaultProps = {
    showDivider: true,
    buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true
    }
};
export default ProductCardGridMobileComponent;
